import React from 'react';
import { useLayoutContext } from '../../providers/LayoutProvider';

import { BottomLinksFooter } from './BottomLinksFooter/BottomLinksFooter';
import './Footer.scss';
import { AccordionMenu } from '../Header/MainMenu/AccordionMenu';
import { FooterMenu } from '../Header/MainMenu/FooterMenu';

import { TopActionFooter } from './TopActionFooter/TopActionFooter';

export const Footer = () => {
    const { heroCarouselRef } = useLayoutContext();
    const carouselMargin = heroCarouselRef.current !== undefined ? true : false;

    return (
        <footer className={`footer__main ${carouselMargin ? `carousel` : ``}`}>
            <TopActionFooter />
            <div className="footer__menu--mobile">
                <AccordionMenu footer={true} />
            </div>
            <div className="footer__menu--desktop">
                <FooterMenu />
            </div>
            <BottomLinksFooter />
        </footer>
    );
};
